export const TAX_CLASSIFICATION_OPTIONS = [
  { value: 'individual_sole_proprietor_single_member_llc', label: 'Individual/Sole Proprietor or Single-Member LLC' },
  { value: 'llc_c', label: 'Limited Liability Company C Corporation' },
  { value: 'llc_s', label: 'Limited Liability Company S Corporation' },
  { value: 'llc_partnership', label: 'Limited Liability Company Partnership' },
  { value: 'c_corporation', label: 'C Corporation' },
  { value: 's_corporation', label: ' S Corporation' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'trust_estate', label: ' Trust/Estate' },
]

export const TAX_IDENTIFICATION_METHOD_SSN = 'ssn'
export const TAX_IDENTIFICATION_METHOD_EIN = 'ein'
export const TAX_IDENTIFICATION_METHOD_OPTIONS = [
  { value: TAX_IDENTIFICATION_METHOD_SSN, label: 'SSN' },
  { value: TAX_IDENTIFICATION_METHOD_EIN, label: 'EIN' },
]

export const W9_FILE_MAX_SIZE_MB = 10
export const W9_FILE_MAX_SIZE = W9_FILE_MAX_SIZE_MB * 1024 * 1024 // W9 size in MB
